import { Component, ChangeDetectionStrategy, inject, signal, computed, effect, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule, CardModule, AlertModule } from '@coreui/angular-pro';
import { IconModule } from '@coreui/icons-angular';
import { TranslationModule, I18nService } from 'i18n';
import { OrderWizardService } from '../../../../../services/order-wizard.service';

@Component({
  selector: 'app-order-success',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule,
    CardModule,
    AlertModule,
    IconModule,
    TranslationModule
  ],
  templateUrl: './order-success.component.html',
  styleUrls: ['./order-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderSuccessComponent {
  @Input() orderId: number | null = null;
  @Input() isFirstOrder: boolean = false;

  private i18n = inject(I18nService);
  private router = inject(Router);
  private wizardService = inject(OrderWizardService);

  // ────────────────────────────────────────────────
  // Reactive state
  // ────────────────────────────────────────────────
  currentLang = signal<string>('en');

  // Computed
  dashboardUrl = computed(() => `/${this.currentLang()}/dashboard`);
  orderWizardUrl = computed(() => `/${this.currentLang()}/order-wizard`);

  // ────────────────────────────────────────────────
  // Effects + Initialization
  // ────────────────────────────────────────────────
  constructor() {
    // Sync current language reactively
    effect((onCleanup) => {
      const subscription = this.i18n.currentLanguage$.subscribe(lang => {
        this.currentLang.set(lang || 'en');
      });
      onCleanup(() => subscription.unsubscribe);
    });
  }

  // ────────────────────────────────────────────────
  // Actions
  // ────────────────────────────────────────────────
  continueShopping(): void {
    // Reset wizard completely
    this.wizardService.reset();

    // Navigate via router with forced reload pattern
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([this.orderWizardUrl()]);
    });
  }
}